// src/components/CaseSummary/index.jsx
// Building blocks for the Summary tab of the Walk-In and Pledge Release case
// detail pages: titled info sections and a responsive
// label/value grid. Kept presentational — callers decide what to show and
// apply their own field-level permissions.
import React from 'react';
import './CaseSummary.css';

const isBlank = (v) => v === undefined || v === null || v === '';

/** A titled card holding an InfoGrid (or any children). */
export function SummarySection({ title, icon, extra, children, full = false }) {
  return (
    <section className={`cs-section${full ? ' cs-section-full' : ''}`}>
      <header className="cs-section-head">
        <span className="cs-section-title">
          {icon && <span className="cs-section-icon">{icon}</span>}
          {title}
        </span>
        {extra}
      </header>
      <div className="cs-section-body">{children}</div>
    </section>
  );
}

/** Label/value grid. Each field: { label, value, wide?, mono? }; falsy entries are skipped. */
export function InfoGrid({ fields, columns = 2 }) {
  const visible = (fields || []).filter(Boolean);
  return (
    <dl className={`cs-grid cs-cols-${columns}`}>
      {visible.map((f) => (
        <div key={f.label} className={`cs-field${f.wide ? ' cs-field-wide' : ''}`}>
          <dt>{f.label}</dt>
          <dd className={[isBlank(f.value) ? 'cs-empty' : '', f.mono ? 'cs-mono' : ''].join(' ').trim()}>
            {isBlank(f.value) ? '—' : f.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}

/** Responsive two-column layout for SummarySection cards. */
export function SummaryLayout({ children }) {
  return <div className="cs-layout">{children}</div>;
}
